import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { ADSTERRA } from "@/ads/adsterraConfig";
import { bannerDoc } from "@/ads/adsterra";

const useIsMobile = () => {
  const q = "(max-width: 767px)";
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = (e) => setM(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return m;
};

// size: "728x90" | "468x60" | "320x50" | "300x250" | "native"; mobileSize used under 768px.
export default function AdBlock({ id, size, mobileSize, label, className = "", desktopOnly = false }) {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  if (user?.tier === "premium" || (desktopOnly && isMobile)) return null;

  const s = isMobile && mobileSize ? mobileSize : size;
  const code = s === "native" ? ADSTERRA.native : ADSTERRA.banners[s];
  const [w, h] = s === "native" ? ["100%", ADSTERRA.nativeHeight] : (s || "0x0").split("x").map(Number);

  if (code && code.trim()) {
    return (
      <div id={id} data-testid={id} data-ad-slot={id} data-ad-size={s} className="flex justify-center shrink-0 overflow-hidden">
        <iframe title={id} srcDoc={bannerDoc(code)} width={w} height={h} scrolling="no"
          style={{ border: 0, maxWidth: "100%" }} />
      </div>
    );
  }
  return (
    <div id={id} data-testid={id} data-ad-slot={id} data-ad-size={s}
      className={`relative rounded-2xl border border-dashed border-white/10 bg-white/[0.02] flex items-center justify-center overflow-hidden shrink-0 ${className}`}>
      <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground/60">{label || `Ad ${s}`}</span>
    </div>
  );
}
